
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank5 as ObiRank5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-5.js';
 
 
 

 
 export const ObiRank5 = createComponent({
   react: React,
   tagName: 'obi-rank-5',
   elementClass: ObiRank5Element,
   events: {
     
   }
  });
 
 